var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.tree)?_c('div',[_vm._v("Loading...")]):_c('div',[_c('ul',[_c('GenealogyNode',{attrs:{"node":_vm.tree}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }